import React from "react";
import { Link } from "gatsby";
import { useWebsiteStatus } from "./provider";
import "./status.css";

export default function WebsiteStatusBanner() {
  const status = useWebsiteStatus();
  return (
    <div aria-live="polite" aria-atomic="true">
      {status.showBanner && (
        <aside
          className={`website-status-notice website-status-banner website-status-${status.severity}`}
          aria-label="Service notice"
        >
          <Link to="/status/">
            {status.message}
            {status.stale ? " (last known update)" : ""}{" "}
            <span className="website-status-details">View status →</span>
          </Link>
        </aside>
      )}
    </div>
  );
}
